import React, { useState, useEffect, useRef } from 'react';
import { css } from '@emotion/core';
import Grow from '@material-ui/core/Grow';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import Typography from '@material-ui/core/Typography';

export default function MontageImg({
    src,
    alt,
    animationInTime = 500,
    isShowPlayIcon = false,
    isShowWorkInformation,
    setReady,
    igGame = false,
    igUrl,
    ...restProps
}) {
    const imgRef = useRef();
    const [loaded, setLoaded] = useState(false);
    const { ugcAuthorName: name, title } = restProps;

    useEffect(() => {
        const onLoad = () => setLoaded(true);

        if (Boolean(imgRef.current?.complete) && Boolean(src)) {
            onLoad();
        } else {
            imgRef.current.onload = onLoad;
        }
    }, [src]);

    useEffect(() => {
        setReady(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grow in={loaded} timeout={animationInTime}>
            <div css={containerStyle}>
                {isShowWorkInformation && (
                    <Typography css={nameStyle} variant="body2">
                        {name}
                    </Typography>
                )}
                <img css={imgStyle} ref={imgRef} src={src} alt={alt} {...restProps} />
                {isShowPlayIcon && <PlayCircleFilledWhiteIcon css={playIconStyle} />}
                {isShowWorkInformation && (
                    <Typography css={nameStyle} variant="body2">
                        {title}
                    </Typography>
                )}
                {igGame && (
                    <a href={igUrl}>
                        <img
                            src="https://assets.fevercdn.com/promotion/icon/ig_logo.svg"
                            alt="instagramAccount"
                            css={igIconStyle}
                        />
                    </a>
                )}
            </div>
        </Grow>
    );
}

const containerStyle = css`
    position: relative;
    ${'' /* background: #ffffff;
    box-shadow: 0px 1px 3px rgb(0 0 0 / 20%), 0px 2px 2px rgb(0 0 0 / 12%),
        0px 0px 2px rgb(0 0 0 / 14%);
    border-radius: 16px;
    margin-bottom: 8px; */}
`;

const imgStyle = css`
    background-image: linear-gradient(135deg, rgb(221, 221, 221), rgb(238, 238, 238));
    border-radius: 8px;
`;

const playIconStyle = css`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    max-width: 53px;
    max-height: 53px;
    color: #ffffff;
    width: 100%;
    height: 100%;
`;

const nameStyle = css`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.15px;
    margin: 14.5px 16px 10.5px;
`;

const igIconStyle = css`
    position: absolute;
    width: 24px;
    height: 24px;
    left: 16px;
    bottom: 24px;
`;
